import { apiClient } from "@nabble/sdk";

export interface Passkey {
  id: string;
  label: string;
  createdAt: string;
  lastUsedAt: string | null;
}

export function startTotpEnrollment(): Promise<{ secret: string; otpauthUri: string }> {
  return apiClient<{ secret: string; otpauthUri: string }>("/api/account/totp", { method: "POST" });
}

export function confirmTotpEnrollment(code: string): Promise<void> {
  return apiClient<void>("/api/account/totp/confirm", { method: "POST", body: { code } });
}

export function removeTotp(): Promise<void> {
  return apiClient<void>("/api/account/totp", { method: "DELETE" });
}

export function startPasskeyEnrollment(): Promise<unknown> {
  return apiClient("/api/account/passkeys/options", { method: "POST" });
}

export function confirmPasskeyEnrollment(credential: unknown, label: string): Promise<void> {
  return apiClient<void>("/api/account/passkeys", { method: "POST", body: { credential, label } });
}

export function removePasskey(id: string): Promise<void> {
  return apiClient<void>(`/api/account/passkeys/${id}`, { method: "DELETE" });
}

export function regenerateRecoveryCodes(): Promise<{ recoveryCodes: string[] }> {
  return apiClient<{ recoveryCodes: string[] }>("/api/account/recovery-codes", { method: "POST" });
}
